import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { X, Archive, Trash2, CheckCircle2, ArrowRightLeft } from "lucide-react";

export const BulkActionBar = ({ selectedCount, columns, onBulkAction, onClear }) => {
  if (selectedCount === 0) return null;
  return (
    <div
      className="fixed bottom-6 left-1/2 -translate-x-1/2 z-50 bg-card/95 backdrop-blur-xl border border-border shadow-2xl rounded-full pl-4 pr-2 py-2 flex items-center gap-2 animate-in slide-in-from-bottom-4"
      data-testid="bulk-action-bar"
    >
      <span className="text-sm font-medium px-2" data-testid="bulk-selected-count">
        {selectedCount} selected
      </span>
      <div className="h-6 w-px bg-border" />

      <Select onValueChange={(colId) => onBulkAction("move", { column_id: colId })}>
        <SelectTrigger className="h-8 w-32 rounded-full border-dashed text-xs" data-testid="bulk-move-select">
          <ArrowRightLeft className="h-3.5 w-3.5 mr-1" />
          <SelectValue placeholder="Move to" />
        </SelectTrigger>
        <SelectContent>
          {columns.map(c => (
            <SelectItem key={c.id} value={c.id}>
              <span className="flex items-center gap-2">
                <span className="w-2 h-2 rounded-full" style={{ backgroundColor: c.color }} />
                {c.name}
              </span>
            </SelectItem>
          ))}
        </SelectContent>
      </Select>

      <Button
        variant="ghost"
        size="sm"
        className="rounded-full h-8 gap-1.5 text-xs"
        onClick={() => onBulkAction("complete")}
        data-testid="bulk-complete-btn"
      >
        <CheckCircle2 className="h-3.5 w-3.5 text-emerald-500" />
        Complete
      </Button>

      <Button
        variant="ghost"
        size="sm"
        className="rounded-full h-8 gap-1.5 text-xs"
        onClick={() => onBulkAction("archive")}
        data-testid="bulk-archive-btn"
      >
        <Archive className="h-3.5 w-3.5" />
        Archive
      </Button>

      <Button
        variant="ghost"
        size="sm"
        className="rounded-full h-8 gap-1.5 text-xs text-destructive hover:bg-destructive/10 hover:text-destructive"
        onClick={() => onBulkAction("delete")}
        data-testid="bulk-delete-btn"
      >
        <Trash2 className="h-3.5 w-3.5" />
        Delete
      </Button>

      <div className="h-6 w-px bg-border" />

      <Button
        variant="ghost"
        size="icon"
        className="rounded-full h-8 w-8"
        onClick={onClear}
        data-testid="bulk-clear-btn"
        title="Clear selection (Esc)"
      >
        <X className="h-4 w-4" />
      </Button>
    </div>
  );
};
